<template>
  <DropZone :accept="accept" @files-dropped="handleNewFiles">
    <p class="txt-body-s-bold">{{ t('FestivalShop.products.details.configure.uploader.drag_n_drop') }}</p>
    <button class="btn-outline-neutral-xs" @click="fileInput?.click()">
      {{ t('FestivalShop.products.details.configure.uploader.select_from_computer') }}
    </button>
    <input
      ref="fileInput"
      type="file"
      class="absolute -z-[1] h-[0.1px] w-[0.1px] overflow-hidden opacity-0"
      :accept="accept.join(', ')"
      multiple
      @change="onFilePicked"
    />

    <div v-if="selectedFiles.length" class="mt-4 w-full p-2">
      <h3 class="mb-2 txt-body-s-regular">{{ t('FestivalShop.products.details.configure.uploader.selected_files') }}</h3>
      <div class="flex w-full flex-col gap-2">
        <div
          v-for="f in selectedFiles"
          :key="f.name"
          class="relative line-clamp-1 rounded-sm border border-subtle bg-surface-elevation-2 p-2 pr-10 break-all"
        >
          {{ f.name }}
          <Trash2 class="absolute top-2.5 right-2.5 cursor-pointer" :size="16" @click="removeFile(f)" />
        </div>
      </div>
    </div>
  </DropZone>
</template>
<script lang="ts" setup>
import { Trash2 } from '@ramp106/omrjs-core-ui/icons'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import DropZone from './DropZone.vue'

const props = defineProps<{
  modelValue: File[]
  accept: string[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: File[]): void
}>()

const fileInput = ref<HTMLInputElement | null>(null)
const selectedFiles = ref<File[]>([])

const { t } = useI18n()

watch(
  () => props.modelValue,
  (value) => {
    selectedFiles.value = [...value]
  },
  { immediate: true },
)

const removeFile = (f: File) => {
  selectedFiles.value = [...selectedFiles.value.filter((sf) => sf.name != f.name)]
  emit('update:modelValue', selectedFiles.value)
}

const handleNewFiles = (files: File[]) => {
  selectedFiles.value = [...selectedFiles.value, ...files]
  emit('update:modelValue', selectedFiles.value)
}

const onFilePicked = (evt: Event) => {
  const el = evt.target as HTMLInputElement
  if (el.files?.length) {
    const newFiles: File[] = []
    for (let i = 0; i < el.files.length; i++) {
      newFiles.push(el.files.item(i)!)
    }
    handleNewFiles(newFiles)
  }
  if (fileInput.value?.value) fileInput.value.value = ''
}
</script>
